export default __webpack_public_path__ + "static/media/FindLivingSpaceDemo.ad19743a.mp4";